import { render } from "./selectShop.vue?vue&type=template&id=3d583baa&scoped=true"
import script from "./selectShop.vue?vue&type=script&lang=js"
export * from "./selectShop.vue?vue&type=script&lang=js"

import "./selectShop.vue?vue&type=style&index=0&id=3d583baa&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d583baa"]])

export default __exports__